import styled from 'styled-components';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "HiddenElementOverlay__StyledDiv"
})([".hs-private.hs-private.hs-private &{background:", ";opacity:0.7;position:absolute;top:0;left:0;right:0;bottom:0;z-index:6;}"], ({
  theme
}) => theme.color['fill-surface-default']);
function HiddenElementOverlay() {
  return /*#__PURE__*/_jsx(NamespaceWrapper, {
    children: /*#__PURE__*/_jsx(StyledDiv, {
      "data-test-id": "hidden-element-overlay"
    })
  });
}
export default HiddenElementOverlay;